export interface IQualityControlDocumentResponse {
  AppraisalDocumentName: string;
  AppraisalDocumentType: number;
  AppraisalId: number;
  FileName: string;
  FileUploaded: boolean;
  FileWebPath: string;
}
